import React from 'react';
import 'twin.macro';
import { TitleRow } from '../text';
import { SearchForm } from '../form';
import { CloseMenuButton, BackToMenuButton } from './';

const leftBlock = () => <BackToMenuButton />;
const rightBlock = () => <CloseMenuButton />;
export const SearchMenu = () => {
  return (
    <div tw='h-full w-full flex flex-col justify-start items-center '>
      <TitleRow
        Type='h2'
        text='Zoeken'
        tw='mb-4 uppercase w-full'
        LeftBlock={leftBlock}
        RightBlock={rightBlock}
      />
      <SearchForm />
    </div>
  );
};
